import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Grid,
  TextField,
  Typography,
  Link,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Dialog,
  DialogContent,
  DialogTitle,
  Card,
  DialogActions,
  DialogContentText,
  ListItem,
  ListItemText,
  List,
  Button
} from "@mui/material"; //FB 8011
import { GetAdminSettingValue, GetPharmacySession, InsertPPLogs, VerifyLogin } from "../../../api";//FB 6997
import UseStyle from "../../../css/styles";
import { Login, Patient } from "../../../store/index"; //FB 8011
import { UserContext } from "../../../App";
import useMediaQuery from "@mui/material/useMediaQuery";
import ResetPassword from "./resetPassword";

// Update log
// FB  6192   02/06/2023  DK   Added Login screen
// FB  7110   07/21/2023  GS   Updated label to Username or email for username field
// FB  7438   09/21/2023  DK   Updated the title to Patient Portal
// FB  6997   10/09/2023  SK   Patient Portal: All the api's that shows results in the Patient portal needs fine tuning
// FB  7565   10/11/2023  SK  Rename the Placeholder for Username field in Login and Forgot Password Screen
// FB  8011   01/12/2024  GA   Enhancement Guardian Portal Access to allow single sign in for multiple account viewings
// FB  7876   02/21/2024  GA   Setup Patient Portal for Makovsky
// FB  8568   04/16/2024  DK  Guardian is not able to see the patient profile details


export default function LoginPage() {
  const matches = useMediaQuery("(min-width:600px)");

  const styles = UseStyle();
  const navigate = useNavigate();
  const JSAlert = require("js-alert");
  const context = useContext(UserContext);
  const [open, setOpen] = useState(false);
  const [close, setClose] = useState(false);
  const [showUserSelectionModal, setShowUserSelectionModal] = useState(false);//FB 8011
  const [multipleUsers, setMultipleUsers] = useState<any[]>(); //FB 8011

  const [loginform, setLoginForm] = useState({
    Username: "",
    Password: "",
    IsGuardian: false,
  } as Login);
  const [errors, setErrors] = useState({ Username: false, Password: false });
  const handleInputChange = (e: any) => {
    setErrors({ ...errors, [e.target.name]: false });
    if (e.target.name === "IsGuardian") {
      setLoginForm({ ...loginform, [e.target.name]: e.target.checked });
    } else {
      setLoginForm({ ...loginform, [e.target.name]: e.target.value });
    }
  };

  //FB 8011
  const handleClose = () => {
    setShowUserSelectionModal(false);
  };

  const validate = () => {
    if (loginform.Username == undefined || loginform.Username === "") {
      setErrors((errors) => ({ ...errors, Username: true }));
      return false;
    }
    if (loginform.Password == undefined || loginform.Password === "") {
      setErrors((errors) => ({ ...errors, Password: true }));
      return false;
    }
    return true;
  };
  let g;
  //FB 8011 Begin
  const handleListItemClick = (user: any) => {

    let data = {
      Login: loginform.IsGuardian ? user.login : loginform.Username,
      Patient_n: user.patientID,
      EMRID: user.emrid,
      PatientFirstName: user.patientFirstName,
      PatientLastName: user.patientLastName,
      PatientZIP: user.patientZIP,
      PatientDOB: user.patientDOB,
      PatientGender: user.patientGender,
      IsGuardian: loginform.IsGuardian,
      Guardian: user.patientGuardian,
    };

    const abc = new Date(user.patientDOB);
    const DOBValue = abc.toLocaleDateString("en-ZA");
    let g;
    if (data.PatientGender === "male") {
      g = 1;
    } else {
      g = 2;
    }

    let dataph = {
      PatientFirstName: user.patientFirstName,
      PatientLastName: user.patientLastName,
      PatientZIP: user.patientZIP,
      PatientDOB: DOBValue,
      PatientGender: g,
    };

    // Call your functions or update state with the selected user's data
    GetPharmacySession(dataph);
    sessionStorage.setItem("user", JSON.stringify(data));
    context.setUserLoggedIn(true);
    navigate("/user/home/dashboard");
    InsertPPLogs("Sign In ", window.location.href, loginform.Username, "");

    // Close the modal
    setShowUserSelectionModal(false);
  };

  const handlesingleDependent = (user: any) => {
    //FB 8568
    let data = {
      Login: loginform.IsGuardian ? user[0].login : loginform.Username,
      Patient_n: user[0].patientID,
      EMRID: user[0].emrid,
      PatientFirstName: user[0].patientFirstName,
      PatientLastName: user[0].patientLastName,
      PatientZIP: user[0].patientZIP,
      PatientDOB: user[0].patientDOB,
      PatientGender: user[0].patientGender,
      IsGuardian: loginform.IsGuardian,
      Guardian: user[0].patientGuardian,
    };

    const abc = new Date(user[0].patientDOB);
    const DOBValue = abc.toLocaleDateString("en-ZA");
    let g;
    if (data.PatientGender === "male") {
      g = 1;
    } else {
      g = 2;
    }

    let dataph = {
      PatientFirstName: user[0].patientFirstName,
      PatientLastName: user[0].patientLastName,
      PatientZIP: user[0].patientZIP,
      PatientDOB: DOBValue,
      PatientGender: g,
    };

    // Call your functions or update state with the selected user's data
    GetPharmacySession(dataph);
    sessionStorage.setItem("user", JSON.stringify(data));
    context.setUserLoggedIn(true);
    navigate("/user/home/dashboard");
    InsertPPLogs("Sign In ", window.location.href, loginform.Username, "");

    // Close the modal
    setShowUserSelectionModal(false);
  };
  //FB 8011 End
  async function handleLogin(event: React.SyntheticEvent) {
    event.preventDefault();
    // FB 6997 - Begin
    //FB 7876 Begin -Removed old code
    let setting = await GetAdminSettingValue("enable_portal_dashboard_options");
    sessionStorage.setItem("enable_portal_dashboard_options", setting);
    //FB 7876 End
    // FB 6997 - End
    if (validate()) {
      const user = await VerifyLogin(loginform);
      if (user != undefined) {
        if (user == "Existing patient identified") {
          setOpen(true);
        }
        //FB 8011 Begin
        else if (Array.isArray(user) && user.length > 1) {
          setMultipleUsers(user);
          setShowUserSelectionModal(true);
        }
        else if (Array.isArray(user) && user.length == 1) {
          setMultipleUsers(user);
          handlesingleDependent(user);
        }
        //FB 8011 End
        else if (user.patientID != 0) {
          let data = {
            Login: loginform.IsGuardian ? user.login : loginform.Username,
            Patient_n: user.patientID,
            EMRID: user.emrid,
            PatientFirstName: user.patientFirstName,
            PatientLastName: user.patientLastName,
            PatientZIP: user.patientZIP,
            PatientDOB: user.patientDOB,
            PatientGender: user.patientGender,
            IsGuardian: loginform.IsGuardian,
            Guardian: user.patientGuardian,
          };
          const abc = new Date(user.patientDOB);
          const DOBValue = abc.toLocaleDateString("en-ZA");
          if (data.PatientGender == "male") {
            g = 1;
          } else {
            g = 2;
          }
          let dataph = {
            PatientFirstName: user.patientFirstName,
            PatientLastName: user.patientLastName,
            PatientZIP: user.patientZIP,
            PatientDOB: DOBValue,
            PatientGender: g,
          };
          GetPharmacySession(dataph);
          sessionStorage.setItem("user", JSON.stringify(data));
          context.setUserLoggedIn(true);
          navigate("/user/home/dashboard");
          InsertPPLogs("Sign In ", window.location.href, loginform.Username, "");
        }
        else {
          JSAlert.alert(
            "Invalid credentials. Please enter a valid username and password.",
            null,
            JSAlert.Icons.Failed
          );
        }
      }
    }
  };

  useEffect(() => {
    if (close) {
      navigate("/user/login");
    }
  }, [close]);

  return (

    <>
      <form onSubmit={handleLogin}>

        <Grid
          container
          spacing={1}
          flexDirection="column"
        //  padding={3}
        >
          <Grid
            item
            xs={12}
            style={{
              backgroundColor: "#F5F5F5",
              minHeight: "75px",
              alignItems: "center",
              display: "flex",
              paddingLeft: matches == false ? "20px" : "90px",
            }}
          >
            {/* FB 7438 */}
            <Typography variant="h5" style={{ backgroundColor: "#F5F5F5" }}>
              <b>Log in to Your Patient Portal account</b>
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            style={{
              marginLeft: matches == false ? "16px" : "80px",
              marginTop: "15px",
            }}
          >
            <Typography variant="h6">
              <b>Sign in</b>
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            style={{
              marginLeft: matches == false ? "16px" : "80px",
            }}
          >
            {/* FB 7438 */}
            <Typography variant="body1">
              Enter your Patient Portal account details
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            style={{
              marginLeft: matches == false ? "16px" : "80px",
              marginTop: "15px",
            }}
          >
            <Typography variant="body1">
              Don’t have an account yet? <a href="/user/signup">Sign up</a>
            </Typography>
            <hr />
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={6}
            lg={4}
            style={{
              marginLeft: matches == false ? "16px" : "80px",
              paddingRight: matches == false ? "16px" : "",
            }}
          >
            <TextField
              id="username"
              name="Username"
              label="Username" //FB  7110  //FB 7565
              value={loginform.Username}
              onChange={handleInputChange}
              error={errors.Username}
              variant="outlined"
              required
              fullWidth
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={6}
            lg={4}
            style={{
              marginLeft: matches == false ? "16px" : "80px",
            }}
          >
            <Link href="/user/forgotusername" underline="hover">
              Forgot Username?
            </Link>
          </Grid>
          <br></br>
          <Grid
            item
            xs={12}
            sm={6}
            md={6}
            lg={4}
            style={{
              marginLeft: matches == false ? "16px" : "80px",
              paddingRight: matches == false ? "16px" : "",
            }}
          >
            <TextField
              type="password"
              id="password"
              name="Password"
              label="Password"
              value={loginform.Password}
              onChange={handleInputChange}
              error={errors.Password}
              variant="outlined"
              required
              fullWidth
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={6}
            lg={4}
            style={{
              marginLeft: matches == false ? "16px" : "80px",
            }}
          >
            <Link href="/user/forgotpassword" underline="hover">
              Forgot Password?
            </Link>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={6}
            lg={4}
            style={{
              marginLeft: matches == false ? "16px" : "80px",
            }}
          >
            <FormGroup style={{ color: "#083A4D" }}>
              <FormControlLabel
                control={
                  <Checkbox name="IsGuardian" onChange={handleInputChange} />
                }
                label="I am a Guardian"
              />
            </FormGroup>
          </Grid>
          <Grid item xs={6} sm={3} md={2}>
            <button
              type="submit"
              className="btn"
              style={{
                marginLeft: matches == false ? "16px" : "80px",

                marginTop: "20px",
                marginBottom: "60px",
                backgroundColor: "#13607C",
                color: "white",
              }}
            //onClick={handleLogin}
            >
              Sign In
            </button>
          </Grid>
        </Grid>
        {/* FB 8011 Begin */}
        <Dialog
          open={showUserSelectionModal}
          // onClose={handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Your account is associated with multiple accounts</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Choose a patient from the list below:
            </DialogContentText>
            <List>
              {multipleUsers?.map((elem: any) => (
                <Card key={elem.patientID} style={{ marginBottom: 10 }}>
                  <ListItem>
                    <Button
                      fullWidth
                      onClick={() => handleListItemClick(elem)}
                    >
                      <ListItemText
                        primary={`Last Name: ${elem.patientLastName}`}
                        secondary={`Date of Birth: ${new Date(elem.patientDOB).toLocaleDateString("en-ZA")}`}
                      />
                    </Button>
                  </ListItem>
                </Card>

              ))}
            </List>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
        {/* FB 8011 End */}
      </form>
      <Dialog fullWidth maxWidth={"md"} open={open}>
        <DialogTitle alignContent="center" justifyContent="center" style={{ display: "flex" }}>
          <Typography variant="h5" style={{ color: "#13607C" }}>
            Please reset your password to continue
          </Typography>
        </DialogTitle>
        <DialogContent>
          <ResetPassword login={loginform.Username} setClose={setClose} />
        </DialogContent>
      </Dialog>
    </>
  );
}
